import * as React from "react";
import { Input } from "@neworbit/simpleui-input";
import { Button } from "semantic-ui-react";
import { createValidator } from "not-valid";

interface Props {
    onSearch: (postcode: string, distance: number) => void;
    buttonText: string;
}

interface State {
    postcode: string;
    distance: number;
    showErrors: boolean;
}

export class PostcodeAndDistanceSearch extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { postcode: null, distance: 10, showErrors: false };
        this.onSearch = this.onSearch.bind(this);
    }

    public render() {
        return (
            <>
                <Input.Text
                    value={this.state.postcode}
                    label="Postcode"
                    placeholder="Find rooms near postcode"
                    onChange={(postcode) => this.setState({ postcode })}
                    required
                    showErrors={this.state.showErrors}
                />
                <Input.Number
                    value={this.state.distance}
                    label="Distance"
                    onChange={(distance) => this.setState({ distance })}
                    validation={[createValidator(x => x > 0, "Please enter a distance greater than 0")]}
                    placeholder="within (miles)"
                    required
                    showErrors={this.state.showErrors}
                />
                <Button
                    primary
                    type="button"
                    floated="right"
                    onClick={this.onSearch}
                >
                    {this.props.buttonText}
                </Button>
            </>
        );
    }

    public onSearch() {
        this.setState({ showErrors: true });
        if (this.state.postcode && this.state.distance && this.state.distance > 0) {
            this.props.onSearch(this.state.postcode, this.state.distance);
        }
    }
}
